import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiLogsService } from 'src/app/services/apiclient/api-logs/api-logs.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateArrayService } from 'src/app/services/translateArray/translate';

@Component({
  selector: 'app-client-account-logs',
  templateUrl: './client-account-logs.component.html',
  styleUrls: ['./client-account-logs.component.css']
})
export class ClientAccountLogsComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator|any;
  @ViewChild(MatSort, { static: true }) sort: MatSort|any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['api_route_date', 'api_route', 'api_route_type', 'description'];

  dataLength: number = 2000;
  pageSize: number = 50;

  // Loaders
  loaders: any = {
    logs: true
  }

  constructor(
    private logsApi: ApiLogsService,
    private TranslateArrayService: TranslateArrayService
  ) { }

  ngOnInit() {
    this.getClientAccountLogs();
  }

  getClientAccountLogs() {
    this.logsApi.getClientAccountLogs().then(data => {
      this.dataSource.data = data.client_account_logs;
      this.dataSource.paginator = this.paginator;
 
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);
      this.loaders.logs = false;
    })
  }


}
